/*
  Bấm vào dãy sao dưới tên sản phẩm → cuộn xuống khối đánh giá.

  Dãy sao là block `review` của theme (blocks/review.liquid), vẽ từ metafield
  `reviews.rating` mà Judge.me đồng bộ sang. Nó chỉ là thẻ div trơn, không phải
  huy hiệu của Judge.me, nên không có sẵn hành vi bấm-để-cuộn — phải tự gắn.

  ĐÍCH CUỘN

  Ưu tiên `.jdgm-review-widget`, nhưng thẻ đó do Judge.me chèn bằng JS nên lúc
  trang vừa tải chưa tồn tại. Vì vậy có thêm phương án hai: thẻ bọc app block
  `[id*="judge_me_reviews_review_widget"]` — thẻ này Shopify render sẵn ở server
  nên luôn có mặt, kể cả khi script của Judge.me còn chưa chạy hoặc bị chặn.

  Đích được tra lại tại thời điểm bấm, không phải lúc nạp trang: widget tải chậm
  và cao dần khi review đổ về, nên toạ độ tính sẵn từ đầu sẽ sai.
*/
(function () {
  var RATING = '.rating-wrapper';
  var TARGETS = ['.jdgm-review-widget', '[id*="judge_me_reviews_review_widget"]'];

  /* Header dính ở đầu trang sẽ che mất phần đầu khối review nếu cuộn đúng bằng
     toạ độ của nó. Chỉ trừ hao khi header thực sự đang sticky/fixed — ở màn hình
     nhỏ hoặc khi cấu hình tắt, nó cuộn theo trang và không cần trừ gì cả. */
  function headerOffset() {
    var candidates = ['.header-section', 'header-component', '.header'];
    var offset = 0;

    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (!el) continue;

      var position = getComputedStyle(el).position;
      if (position !== 'sticky' && position !== 'fixed') continue;

      offset = Math.max(offset, el.getBoundingClientRect().height);
    }

    return offset;
  }

  function reviewsSection() {
    for (var i = 0; i < TARGETS.length; i++) {
      var el = document.querySelector(TARGETS[i]);
      if (el) return el;
    }
    return null;
  }

  /*
    TỪ 990px TRỞ LÊN, TRANG KHÔNG CUỘN BẰNG CỬA SỔ.

    base.css đặt `html, body { height: 100dvh; overflow: hidden }` ở breakpoint
    990px và chuyển việc cuộn sang `.page-wrapper` (`height: 100dvh;
    overflow-y: auto`). Nghĩa là `window.scrollTo()` trên desktop KHÔNG làm gì
    cả — cửa sổ vốn đã không cuộn được. Dưới 990px thì html cuộn bình thường
    nên cùng đoạn mã lại chạy đúng; đó là lý do lỗi chỉ xuất hiện ở desktop.

    Vì vậy phải dò xem ai đang thực sự cuộn rồi mới gọi scroll trên đúng phần tử
    đó. Kiểm tra cả overflow lẫn chiều cao thật, không nhìn mỗi breakpoint: khi
    trang ngắn hơn khung nhìn thì .page-wrapper không cuộn được và cửa sổ mới là
    nơi cần tác động.
  */
  function scrollContainer() {
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return null;

    var overflowY = getComputedStyle(wrapper).overflowY;
    if (overflowY !== 'auto' && overflowY !== 'scroll') return null;
    if (wrapper.scrollHeight <= wrapper.clientHeight + 1) return null;

    return wrapper;
  }

  function scrollToReviews() {
    var el = reviewsSection();
    if (!el) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* 'instant' chứ không phải 'auto': .page-wrapper có sẵn
       `scroll-behavior: smooth` trong CSS, mà 'auto' nghĩa là "theo CSS" nên
       người bật giảm chuyển động vẫn bị cuộn mượt. */
    var behavior = reduceMotion ? 'instant' : 'smooth';
    var container = scrollContainer();
    var gap = headerOffset() + 16;

    if (container) {
      var offsetInside =
        el.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;

      container.scrollTo({ top: Math.max(0, offsetInside - gap), behavior: behavior });
      return;
    }

    window.scrollTo({
      top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - gap),
      behavior: behavior,
    });
  }

  function enhance(el) {
    if (el.dataset.reviewScroll) return;
    el.dataset.reviewScroll = '1';

    el.style.cursor = 'pointer';

    /* Không dùng thẻ <a href="#..."> vì đích chưa tồn tại lúc render, và một
       anchor trỏ vào hư không sẽ làm bẩn URL. Gắn vai trò nút để bàn phím và
       trình đọc màn hình vẫn dùng được. */
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', 'Jump to reviews');

    el.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToReviews();
    });

    el.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      event.preventDefault();
      scrollToReviews();
    });
  }

  function init() {
    document.querySelectorAll(RATING).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor dựng lại section khi chỉnh sửa — gắn lại cho bản mới. */
  document.addEventListener('shopify:section:load', init);
})();
